import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import {
  HighlightHTML
} from "@learningblocks/storybook-components";

export class PlainText extends React.Component {
  render() {

    return (
      <span className={this.props.className}>
        <HighlightHTML
          content={this.props.text}
          getContentData={this.props.getGlossaryItem}
          openGlossary={this.props.onOpenGlossary}
        />
      </span>
    )
    // return React.createElement('span', {
    //   className: this.props.className,
    //   dangerouslySetInnerHTML: {__html: this.props.text},
    // });
  }
}
PlainText.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

PlainText.defaultProps = {
  className: 'plainText',
};
